
























import Vue from "vue"
export default Vue.extend({
  props: {
    'prop': {
      type: Object,
      required: true
    },
    'value': {
      required: true,
      default: ''
    }
  }
})
